// extracted by mini-css-extract-plugin
export default {"preloader":"KeycloakLoader_preloader__uzD09"};